import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppMaterialModule } from './app-material.module';
// import { HttpModule } from '@angular/http';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatNativeDateModule, MatPaginatorIntl } from '@angular/material';
import { CustomPaginator } from './resources/Funciones';
import { DatePipe } from '@angular/common';
import { StorageService } from './services/storage.service';
import { VentanaEmergenteComponent } from './ventana-emergente/ventana-emergente.component';
import { BotonesService } from './services/botones.service';
import { CRespuestaService } from './components/login/shared/CRespuesta.service';
import { InicioComponent } from './components/inicio/inicio.component';
import { PoliticaCookiesComponent } from './components/politica-cookies/politica-cookies.component';
import { BotonesComponent } from './components/botones/botones.component';
import { LoginComponent } from './components/login/login.component';
import { FooterComponent } from './components/footer/footer.component';

@NgModule({
  declarations: [
    AppComponent,
    VentanaEmergenteComponent,
    LoginComponent,
    FooterComponent,
    InicioComponent,
    BotonesComponent,
    PoliticaCookiesComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    AppMaterialModule,
    // HttpModule,
    HttpClientModule,
    BrowserAnimationsModule,
    MatNativeDateModule
  ],
  providers: [BotonesService,CRespuestaService, StorageService, {provide: MatPaginatorIntl, useValue: CustomPaginator() },DatePipe
              
             ],
  bootstrap: [AppComponent],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class AppModule { }
